import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/bess-ess/page.tsx");
